import { createApp } from "vue";
import { createPinia } from "pinia";
import { useCartStore } from "./store";
import CartApp from "./CartApp.vue";
import CartEventBus from "./CartEventBus";
import useCartApi from "./api";
import { extractAppData, extractData } from "../../utils";
import { updateCartFromHTML } from "../../components/cart";
export default function initCartApp() {
    const cartEl = document.getElementById('cartApp');
    const cartDataEl = document.getElementById('cartData');
    if (!cartEl || !cartDataEl) {
        return;
    }
    const api = useCartApi();
    const pinia = createPinia();
    const store = useCartStore(pinia);
    const initialData = extractData(cartDataEl);
    const appData = extractAppData(cartEl);
    const giftNumbers = appData.rules;
    const actionPool = getActionPool(CartEventBus, initialData);
    store.setGiftLimits(appData.minOrderSum, appData.vipMinOrderSum);
    createApp(CartApp, {
        atomizersAvailable: appData?.atomizersAvailable
    }).use(pinia).mount(cartEl);
    CartEventBus.on('cart:update', updateCart);
    CartEventBus.on('cart:refresh', () => actionPool.refreshCart());
    CartEventBus.on('coupons:add', code => store.addCoupon(code) && actionPool.addCoupon(code));
    CartEventBus.on('coupons:remove', code => store.removeCoupon(code) && actionPool.removeCoupon(code));
    CartEventBus.on('gifts:get_giftable', async () => store.setGiftableProducts(await api.getGiftable()));
    CartEventBus.on('gifts:add', async (id) => store.addGift(id) && updateGifts(await api.addGift(id)));
    CartEventBus.on('gifts:remove', async (id) => store.removeGift(id) && updateGifts(await api.removeGift(id)));
    CartEventBus.on('products:delete', deleteProduct);
    CartEventBus.on('products:quantity', updateProductQuantity);
    updateCart(initialData.result, true);
    CartEventBus.emit('loader:show');
    function updateProductQuantity({ product, quantity, oldQuantity }) {
        const diffQuantity = quantity - oldQuantity;
        const storeProduct = store.getProduct(product.cartItemId);
        if (storeProduct) {
            storeProduct.quantity = quantity;
        }
        store.setTotals(store.totalSum + product.price * diffQuantity, store.totalDiscount + product.discountAmount * diffQuantity);
        store.setAvailable(computeGiftsNumber(store.bottles));
        actionPool.changeQuantity(product.cartItemId, quantity, oldQuantity);
    }
    function computeGiftsNumber(bottles) {
        return giftNumbers.find(gift => bottles >= gift.min && (gift.max ? bottles <= gift.max : true))?.gifts ?? 0;
    }
    function deleteProduct(product) {
        store.removeProduct(product.cartItemId);
        store.setTotals(store.totalSum - product.sum, store.totalDiscount - product.fullDiscount);
        store.setAvailable(computeGiftsNumber(store.bottles));
        actionPool.deleteItem(product.cartItemId);
    }
    function updateCart(data, initial = false) {
        store.setCoupons(data.COUPON_LIST.map(coupon => ({
            status: coupon.CHECK_CODE_TEXT.join('\r'),
            code: coupon.COUPON,
            valid: coupon.CHECK_CODE === 0,
            amount: coupon.AMOUNT,
        })));
        store.setProducts(data.BASKET_ITEM_RENDER_DATA);
        if (data.TOTAL_RENDER_DATA) {
            store.setTotals(data.TOTAL_RENDER_DATA.SUM, data.TOTAL_RENDER_DATA.TOTAL_DISCOUNT);
        }
        updateGifts(data.gifts_data);
        updateCartFromHTML(data.cart_block);
        if (!initial) {
            store.initialized = true;
        }
        data.WARNING_MESSAGE.forEach(warning => CartEventBus.emit('warning:show', warning));
        actionPool.setRefreshStatus(true);
    }
    function updateGifts(data) {
        if (!data) {
            return;
        }
        store.setGifts(data.gifts);
        store.setAvailable(data.available);
    }
}
function getActionPool(eventBus, initialData) {
    BX.Sale.BasketComponent.init(initialData, eventBus);
    return BX.Sale.BasketComponent.actionPool;
}
